// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".match-section{background-color:var(--theme-primary-color)}.match-section__heading{color:#fff}.match-section__explanation{margin-bottom:2.5em}", ""]);
// Exports
module.exports = exports;
